import React from 'react'
import { FormattedMessage } from 'react-intl'
import AlertDialog from '../alert-dialog/alert-dialog'
import { withRouter } from 'react-router-dom'

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { error: false, open: false }
    this.error = null
  }

  static getDerivedStateFromError(error) {
    return { error: error.toString(), open: true }
  }

  onClose = () => {
    this.setState({ open: false })
    this.props.history.goBack()
  }

  render() {
    if (this.state.error) {
      return (
        <div>
          <AlertDialog
            openAlert={!!this.state.open}
            title={'error_boundary_title'}
            dialog={<FormattedMessage id='error_boundary_description' />}
            handleClose={this.onClose}
            cancelButtonText={'global_buttons_close'}
          />
        </div>
      )
    }
    // En condiciones normales, simplemente renderiza los hijos
    return this.props.children
  }
}

export default withRouter(ErrorBoundary)
